import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

interface SelectedItemStore {
  selectedItemId: string | null;
  setSelectedItemId: (id: string) => void;
  clearSelectedItemId: () => void;
}

export const useSelectedItemStore = create<SelectedItemStore>()(
  persist(
    (set) => ({
      selectedItemId: null,
      setSelectedItemId: (id: string) => set({ selectedItemId: id }),
      clearSelectedItemId: () => set({ selectedItemId: null }),
    }),
    {
      name: "selected-item-id-storage",
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({ selectedItemId: state.selectedItemId }),
    }
  )
);
